@use '@/styles/variables' as *;

.fieldErrorWrapper {
    font-size: 12px;
    color: $error;
    margin-top: 3px;
    width: 100%;
}
